import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { useTranslation } from "react-i18next";
import Header from "../../layout/Header/Header";
import MenuBotones from "../../MenuBotones";

function BotonesReportes() {
  const { user } = useContext(AuthContext);
  const [t] = useTranslation("global");

  if (!user.contenedoresReporte) return <Header />;

  return (
    <MenuBotones
      titulo={t("Reportes")}
      descripcion={t("Reportes de operación")}
      icono="fas fa-chart-bar"
      color="#7c3aed"
      secciones={[
        {
          section: t("Contenedores"),
          items: [
            { label: t("Reporte Contenedores"), icon: "fas fa-clipboard-list", color: "#7c3aed", href: "/ReporteContenedores",
              desc: t("Contenedores por periodo, cliente y estatus"), enabled: !!user.contenedoresReporte },
          ],
        },
      ]}
    />
  );
}

export default BotonesReportes;
